'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// # Valid currency types

var symbol = '$';

var usd = {
  description: 'US Dollars',
  code: 'usd',
  symbol: symbol,
  longSymbol: 'USD' + symbol
};

var cad = {
  description: 'Canadian Dollars',
  code: 'cad',
  symbol: symbol,
  longSymbol: 'Can' + symbol
};

var mxn = {
  description: 'Mexican Pesos',
  code: 'mxn',
  symbol: symbol,
  longSymbol: 'Mex' + symbol
};

var currencies = exports.currencies = {
  usd: usd,
  mxn: mxn,
  cad: cad
};

var isSupportedCurrency = exports.isSupportedCurrency = function isSupportedCurrency(currency) {
  return currency === usd.code || currency === cad.code || currency === mxn.code;
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/utilities/currency-types.js
// module id = 711
// module chunks = 0